// Lazy load function
const lazyLoad = (file) => () =>
  import(
    /* webpackChunkName: "[request]" */ `@/views/settings/quality-control/${file}.vue`
  );

export default [
  // Complaint Type
  {
    path: "/complaint-type",
    name: "complaint-type",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ComplaintTypeSettings",
    },
    components: {
      content: lazyLoad("complaint-type"),
    },
  },
  {
    path: "/complaint-type/review/:id",
    name: "complaint-type-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ComplaintTypeSettings",
    },
    components: {
      content: lazyLoad("complaint-type"),
    },
  },
  {
    path: "/complaint-type/edit/:id",
    name: "complaint-type-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ComplaintTypeSettings",
    },
    components: {
      content: lazyLoad("complaint-type"),
    },
  },
  {
    path: "/complaint-type/create",
    name: "complaint-type-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "ComplaintTypeSettings",
    },
    components: {
      content: lazyLoad("complaint-type"),
    },
  },


  // Quality Control - Root Cause Classification
  {
    path: "/root-cause-classification",
    name: "root-cause-classification",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RootCauseClassificationSettings",
    },
    components: {
      content: lazyLoad("root-cause-classification"),
    },
  },
  {
    path: "/root-cause-classification/review/:id",
    name: "root-cause-classification-review",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RootCauseClassificationSettings",
    },
    components: {
      content: lazyLoad("root-cause-classification"),
    },
  },
  {
    path: "/root-cause-classification/edit/:id",
    name: "root-cause-classification-edit",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RootCauseClassificationSettings",
    },
    components: {
      content: lazyLoad("root-cause-classification"),
    },
  },
  {
    path: "/root-cause-classification/create",
    name: "root-cause-classification-create",
    meta: {
      requiresAuth: true,
      applicationFeatureCode: "RootCauseClassificationSettings",
    },
    components: {
      content: lazyLoad("root-cause-classification"),
    },
  },
];
